import all from './all';
import details from './details';

export default {
    all,
    details,
};
